export const NavbarItems = [
    {
        title: "ABOUT",
        url: "/#features"
    },
    // {
    //     title: "TEAM",
    //     url: "/#team"
    // },

    {
        title: "FAQ",
        url: "/FAQ"
    },
    {
        title: "TUTORIAL",
        url: "/tutorial"
    },
    {
        title: "EXAMPLES",
        url: "/examples"
    },

    {
        title: "UPDATES",
        url: "/updates"
    },


    {
        title: "CITE",
        url: "/#cite"
    },


]